import { createElementBlock as t, openBlock as l, createElementVNode as e } from "vue";
const n = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
function r(C, o) {
  return l(), t("svg", n, o[0] || (o[0] = [
    e("g", {
      transform: "translate(1 5)",
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      e("path", {
        d: "M21.5402066,2.34210186 C21.2872206,1.42028951 20.5418447,0.694093298 19.5952751,0.447676948 C17.8796065,0 10.9999095,0 10.9999095,0 C10.9999095,0 4.12039346,0 2.40472486,0.447676948 C1.45815533,0.694093298 0.712779355,1.42028951 0.45979339,2.34210186 C0,4.01339385 0,7.49991181 0,7.49991181 C0,7.49991181 0,10.9866061 0.45979339,12.6577218 C0.712779355,13.5795341 1.45815533,14.3059067 2.40472486,14.5521467 C4.12039346,15 10.9999095,15 10.9999095,15 C10.9999095,15 17.8796065,15 19.5952751,14.5521467 C20.5418447,14.3059067 21.2872206,13.5795341 21.5402066,12.6577218 C22,10.9866061 22,7.49991181 22,7.49991181 C22,7.49991181 22,4.01339385 21.5402066,2.34210186",
        fill: "#D9252A"
      }),
      e("polyline", {
        fill: "#FFFFFE",
        points: "8.8 10.625 14.4571429 7.50017149 8.8 4.375 8.8 10.625"
      })
    ], -1)
  ]));
}
const i = { render: r };
export {
  i as default,
  r as render
};
